import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaExternalLinkAlt, FaMapMarkedAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./LocalInstitucional.css";


import sede1 from "../assets/nosotros/local/banner1.jpg";
import sede2 from "../assets/nosotros/local/banner2.jpg";
import sede3 from "../assets/nosotros/local/banner3.jpg";

const LocalInstitucional = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const googleMapsUrl =
    "https://maps.app.goo.gl/r9bpUA2riufVdLHM8";

  const images = [sede1, sede2, sede3];
  const [currentIndex, setCurrentIndex] = useState(0);


  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="local-page">
  
      <div className="local-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Información de Sede Principal</h1>
          <p className="lead">
            Conoce la ubicación y datos principales de nuestra institución.
          </p>
        </div>
      </div>


      <div className="container py-5">
        <div className="row g-5 align-items-stretch">
       
          <div className="col-lg-6 d-flex flex-column justify-content-between">
          
            
            <div className="mini-banner mb-4 position-relative">
            {images.map((img, index) => (
                <img
                key={index}
                src={img}
                alt={`Imagen ${index + 1}`}
                className={`mini-banner-img ${index === currentIndex ? "active" : ""}`}
                />
            ))}

     
            <button className="arrow left" onClick={prevSlide}>
                <FaChevronLeft />
            </button>
            <button className="arrow right" onClick={nextSlide}>
                <FaChevronRight />
            </button>
            </div>


      
            <div className="mini-map position-relative flex-grow-1">
              <iframe
                title="Ubicación del IESTP Juan Velasco Alvarado"
             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31204.22723892025!2d-76.98743462568356!3d-12.144385900000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105b893c8e5108d%3A0x5ad408d84e80ba37!2sInstituto%20Juan%20Velasco%20Alvarado!5e0!3m2!1ses!2spe!4v1762215855645!5m2!1ses!2spe" 
             width="600" 
             height="450" 
             
             allowfullscreen="" 
             loading="lazy" 
             referrerpolicy="no-referrer-when-downgrade">

             </iframe>
              

              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-mapa-flotante"
              >
                <FaExternalLinkAlt className="me-2" />
                Visitar
              </a>
            </div>
          </div>

         
          <div
            className="col-lg-6 d-flex flex-column justify-content-center"
            data-aos="fade-left"
          >
            <div>
              <h3 className="text-primary mb-4 section-subtitle">
                Información de la Sede Principal
              </h3>

              <p className="descripcion">
                El Instituto de Educación Superior Tecnológico Público{" "}
                <strong>“Juan Velasco Alvarado”</strong> tiene su sede principal
                ubicada en el distrito de Villa María del Triunfo, Lima, Perú.
              </p>

              <ul className="info-list mb-4">
                <li>
                  <strong>Dirección:</strong> Av. José Olaya Nº 120, San Gabriel,
                  Villa María del Triunfo, Lima, Perú
                </li>
                <li>
                  <strong>Teléfono:</strong> (01) 500 6177
                </li>
                <li>
                  <strong>Distrito:</strong> Villa María del Triunfo
                </li>
                <li>
                  <strong>Provincia:</strong> Lima
                </li>
                <li>
                  <strong>País:</strong> Perú
                </li>
              </ul>

              <p className="descripcion mb-4">
                Nuestra institución ofrece una variedad de programas técnicos
                diseñados para preparar a los estudiantes para el mercado laboral
                y contribuir al desarrollo socioeconómico de la región.
              </p>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalInstitucional;
